package kz.dentalcrm.app.screens.service_categories.edit.mvi

import androidx.compose.runtime.Immutable
import kz.dentalcrm.app.core.base.ViewState

@Immutable
data class EditServiceCategoryViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {
    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Editing : ScreenState
        data object Edited : ScreenState
        data object Deleting : ScreenState
        data object Deleted : ScreenState
        data class Error(val error: String) : ScreenState
    }
}
